/**
 * TEST FLASK MODE — Image ↔ Physics Body adjustment panel.
 */
import * as C from "../config/constants.js";
import { runtimeFlags } from "../core/runtime-flags.js";

/**
 * @param {Object} opts - { getFlaskSystem(), isTestFlaskMode() }
 */
function setup(opts) {
  var getFlaskSystem = opts.getFlaskSystem || function () { return null; };
  var isTestFlaskMode = opts.isTestFlaskMode || function () { return false; };

  function getActiveChain() {
    return (typeof C.getActiveEvolutionChain === "function")
      ? C.getActiveEvolutionChain()
      : (C.EVOLUTION_CHAIN || []);
  }
  var select = document.getElementById("adjustTierSelect");
  var radiusInput = document.getElementById("adjustRadiusRatio");
  var radiusVal = document.getElementById("adjustRadiusRatioVal");
  var centerXInput = document.getElementById("adjustCenterX");
  var centerXVal = document.getElementById("adjustCenterXVal");
  var centerYInput = document.getElementById("adjustCenterY");
  var centerYVal = document.getElementById("adjustCenterYVal");
  var aspectInput = document.getElementById("adjustEllipseAspect");
  var aspectVal = document.getElementById("adjustEllipseAspectVal");
  var angleInput = document.getElementById("adjustEllipseAngle");
  var angleVal = document.getElementById("adjustEllipseAngleVal");
  var contourCheck = document.getElementById("adjustShowContour");
  var flaskOutlineCheck = document.getElementById("adjustShowFlaskOutline");
  var resetBtn = document.getElementById("adjustResetBtn");
  var copyAllBtn = document.getElementById("adjustCopyAllBtn");
  var dropRandomBtn = document.getElementById("adjustDropRandomBtn");
  if (!select || !radiusInput) return;

  var chain = getActiveChain();
  select.innerHTML = "";
  for (var i = 0; i < chain.length; i++) {
    var opt = document.createElement("option");
    opt.value = i;
    opt.textContent = chain[i].name + " (" + chain[i].assetId + ")";
    select.appendChild(opt);
  }

  function respawnTestBodies() {
    if (!isTestFlaskMode()) return;
    var sys = getFlaskSystem();
    if (sys) {
      sys.clearBodies();
      sys.spawnTestBodies();
    }
  }

  function syncFromTier() {
    var chainSync = getActiveChain();
    var tier = parseInt(select.value, 10);
    var cfg = chainSync[tier];
    if (!cfg) return;
    var ratio = cfg.imageBodyRadiusRatio != null ? cfg.imageBodyRadiusRatio : 0.45;
    var cx = (cfg.assetCenter && cfg.assetCenter[0] != null) ? cfg.assetCenter[0] : 0.5;
    var cy = (cfg.assetCenter && cfg.assetCenter[1] != null) ? cfg.assetCenter[1] : 0.5;
    var aspect = cfg.ellipseAspect != null ? cfg.ellipseAspect : 1.0;
    var angleDeg = cfg.ellipseAngle != null ? (cfg.ellipseAngle * 180 / Math.PI) : 0;
    radiusInput.value = ratio;
    radiusVal.textContent = ratio.toFixed(3);
    centerXInput.value = cx;
    centerXVal.textContent = cx.toFixed(3);
    centerYInput.value = cy;
    centerYVal.textContent = cy.toFixed(3);
    if (aspectInput) {
      aspectInput.value = aspect;
      aspectVal.textContent = aspect.toFixed(3);
    }
    if (angleInput) {
      angleInput.value = angleDeg;
      angleVal.textContent = angleDeg.toFixed(3);
    }
    contourCheck.checked = !!runtimeFlags.showPhysicsBodyContour;
    if (flaskOutlineCheck) flaskOutlineCheck.checked = !!runtimeFlags.showFlaskPhysicsOutline;
  }

  function applyToTier(respawn) {
    var chainApply = getActiveChain();
    var tier = parseInt(select.value, 10);
    var cfg = chainApply[tier];
    if (!cfg) return;
    cfg.imageBodyRadiusRatio = parseFloat(radiusInput.value);
    cfg.assetCenter = [parseFloat(centerXInput.value), parseFloat(centerYInput.value)];
    if (aspectInput) cfg.ellipseAspect = parseFloat(aspectInput.value);
    if (angleInput) cfg.ellipseAngle = parseFloat(angleInput.value) * Math.PI / 180;
    radiusVal.textContent = cfg.imageBodyRadiusRatio.toFixed(3);
    centerXVal.textContent = cfg.assetCenter[0].toFixed(3);
    centerYVal.textContent = cfg.assetCenter[1].toFixed(3);
    if (aspectInput) aspectVal.textContent = cfg.ellipseAspect.toFixed(3);
    if (angleInput) angleVal.textContent = (cfg.ellipseAngle * 180 / Math.PI).toFixed(3);
    if (respawn) respawnTestBodies();
  }

  select.addEventListener("change", syncFromTier);
  radiusInput.addEventListener("input", function () { applyToTier(false); });
  centerXInput.addEventListener("input", function () { applyToTier(false); });
  centerYInput.addEventListener("input", function () { applyToTier(false); });
  if (aspectInput) aspectInput.addEventListener("input", function () { applyToTier(true); });
  if (angleInput) angleInput.addEventListener("input", function () { applyToTier(true); });
  contourCheck.addEventListener("change", function () {
    runtimeFlags.showPhysicsBodyContour = contourCheck.checked;
  });
  if (flaskOutlineCheck) {
    flaskOutlineCheck.addEventListener("change", function () {
      runtimeFlags.showFlaskPhysicsOutline = flaskOutlineCheck.checked;
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      var tier = parseInt(select.value, 10);
      var chainReset = getActiveChain();
      var cfg = chainReset[tier];
      if (!cfg) return;
      cfg.imageBodyRadiusRatio = 0.45;
      cfg.assetCenter = [0.5, 0.5];
      cfg.ellipseAspect = 1.0;
      cfg.ellipseAngle = 0;
      syncFromTier();
      respawnTestBodies();
    });
  }
  if (copyAllBtn) {
    copyAllBtn.addEventListener("click", function () {
      var chainCopy = getActiveChain();
      var lines = [];
      for (var i = 0; i < chainCopy.length; i++) {
        var c = chainCopy[i];
        var ratio = c.imageBodyRadiusRatio != null ? c.imageBodyRadiusRatio : 0.45;
        var cx = (c.assetCenter && c.assetCenter[0] != null) ? c.assetCenter[0] : 0.5;
        var cy = (c.assetCenter && c.assetCenter[1] != null) ? c.assetCenter[1] : 0.5;
        var aspect = c.ellipseAspect != null ? c.ellipseAspect : 1.0;
        var angle = c.ellipseAngle != null ? c.ellipseAngle : 0;
        lines.push(
          "  { id: " + c.id + ", label: \"" + c.label + "\", name: \"" + c.name + "\", assetId: \"" + c.assetId + "\", assetCenter: [" + cx.toFixed(3) + ", " + cy.toFixed(3) + "], imageBodyRadiusRatio: " + ratio.toFixed(3) + ", ellipseAspect: " + aspect.toFixed(3) + ", ellipseAngle: " + (angle === 0 ? "0" : angle.toFixed(4)) + " },"
        );
      }
      if (lines.length > 0) lines[lines.length - 1] = lines[lines.length - 1].replace(/,\s*$/, "");
      var text = "[\n" + lines.join("\n") + "\n]";
      navigator.clipboard.writeText(text).then(function () {
        copyAllBtn.textContent = "Copied!";
        setTimeout(function () { copyAllBtn.textContent = "Copy all tiers"; }, 1500);
      }).catch(function () {
        copyAllBtn.textContent = "Copy failed";
        setTimeout(function () { copyAllBtn.textContent = "Copy all tiers"; }, 1500);
      });
    });
  }
  if (dropRandomBtn) {
    dropRandomBtn.addEventListener("click", function () {
      if (!isTestFlaskMode()) return;
      var sys = getFlaskSystem();
      var chainDrop = getActiveChain();
      if (!sys || !chainDrop || chainDrop.length === 0) return;
      var tier = Math.floor(Math.random() * chainDrop.length);
      var fallPanelWidth = 100;
      var mouthCenterX = 50;
      var mouthWidth = 100;
      var randomCatchX = Math.random() * fallPanelWidth;
      sys.dropIntoFlask(tier, randomCatchX, fallPanelWidth, mouthCenterX, mouthWidth);
    });
  }
  syncFromTier();
}

export const TestFlaskMode = { setup: setup };
